export default __webpack_public_path__ + "static/media/kleinbus_lang.11f69098.png";